/********************
 ACTION TYPES
 ********************/

export const AUTHENTICATION_INIT = "AUTHENTICATION_INIT";
export const AUTHENTICATION_LOGIN = "AUTHENTICATION_LOGIN";
export const AUTHENTICATION_SUCCEED = "AUTHENTICATION_SUCCEED";
export const AUTHENTICATION_FAILURE = "AUTHENTICATION_FAILURE";
export const AUTHENTICATION_LOGOUT = "AUTHENTICATION_LOGOUT";